import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMegvalositasErtekeles, createMegvalositasErtekeles, updateMegvalositasErtekeles, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import SideTile from "../SideTile";
// import "./MegvalositasErtekeles.css";
import "./SzakjelentesCreate.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import TopAlert from '../../components/TopAlert';
import { MEGVALOSITAS_ERTEKELES_TRANSLATIONS } from './MegvalositasErtekelesTranslations';

const MegvalositasErtekelesContent = ({ szakKod }) => {
    console.log('MegvalositasErtekelesContent rendering with szakKod:', szakKod);

    const [isSideTileVisible] = useState(true);
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();

    console.log('MegvalositasErtekelesContent language state:', { language, loading });

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [megvalositasErtekelesData, setMegvalositasErtekelesData] = useState({
        filling_status: 1,
    });

    const [ertekeles, setErtekeles] = useState("");
    const [isNew, setIsNew] = useState(true);
    const [finalized, setFinalized] = useState(false);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Get translations for current language
    const t = loading ? {} : (MEGVALOSITAS_ERTEKELES_TRANSLATIONS[language] || MEGVALOSITAS_ERTEKELES_TRANSLATIONS.hu);
    console.log('MegvalositasErtekelesContent translations:', { loading, language, hasSidebar: !!t.sidebar, t });

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getMegvalositasErtekeles(szakId);
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    setMegvalositasErtekelesData(data);
                    setFinalized(data.filling_status === 3);
                    
                    if (data.ertekeles) setErtekeles(data.ertekeles);
                    
                    setIsNew(false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                // Handle case when no record exists (404)
                if (error.response && error.response.status === 404) {
                    const newData = {
                        filling_status: 1,
                    };
                    try {
                        await createMegvalositasErtekeles(szakId, newData);
                        setMegvalositasErtekelesData(newData);
                        window.location.reload();
                    } catch (createError) {
                        console.error("Error creating initial record:", createError);
                    }
                }
            }
        };
        fetchData();
    }, [szakId]);

    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...megvalositasErtekelesData, 
                filling_status: 2,
                ertekeles: ertekeles
            };
            try {
                if (isNew) {
                    await createMegvalositasErtekeles(szakId, updatedData);
                } else {
                    await updateMegvalositasErtekeles(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [megvalositasErtekelesData, isNew, szakId, registerSaveHandler, unregisterSaveHandler, ertekeles]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        
        const updatedData = { 
            ...megvalositasErtekelesData, 
            filling_status: status,
            ertekeles: ertekeles
        };

        try {
            if (isNew) {
                await createMegvalositasErtekeles(szakId, updatedData);
            } else {
                await updateMegvalositasErtekeles(szakId, updatedData);
            }
            navigate(0);
        } catch (error) {
            console.error("Hiba az adatok mentésekor:", error);
            alert("Hiba történt az adatok mentésekor.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentesek/${szakId}`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-kommunikacioja`);
    };

    const isFormValid = () => {
        const hasContent = (html) => {
            if (!html) return false;
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        return hasContent(ertekeles);
    };

    const handleFinalize = async (e) => {
        if (megvalositasErtekelesData.filling_status === 3) {
            handleSubmit(e, 2);
        } else {
            if (isFormValid()) {
                handleSubmit(e, 3);
            } else {
                setAlertMessage(t.alerts.requiredFields);
                setShowAlert(true);
            }
        }
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    if (!t || !t.sidebar) {
        console.error('MegvalositasErtekeles: Missing translations or sidebar', { t, language, loading });
        return <div>Error: Missing translations</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <p>{t.description}</p>
                
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <div className="form-group">
                            <RichTextEditor
                                name="ertekeles"
                                value={ertekeles}
                                onChange={setErtekeles}
                                disabled={finalized}
                            />
                        </div>
                    </div>

                    <div className="szak-button-container" style={{ justifyContent: 'space-between' }}>
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>
                            {megvalositasErtekelesData.filling_status === 3 ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

const MegvalositasErtekeles = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    console.log('MegvalositasErtekeles wrapper rendering', { szakId, szakKod, error });

    useEffect(() => {
        const fetchSzakKod = async () => {
            console.log('Fetching szakKod for szakId:', szakId);
            try {
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                console.log('getSzak response.data:', response.data);
                console.log('getSzak response.data.data:', response.data?.data);
                
                if (response.data && response.data.data) {
                    const szakData = response.data.data;
                    const kod = Array.isArray(szakData) ? szakData[0]?.szak_kod : szakData.szak_kod;
                    console.log('Setting szakKod to:', kod);
                    setSzakKod(kod);
                } else {
                    console.error('No data in getSzak response. Full response:', JSON.stringify(response.data));
                    setError("Unable to load program code");
                }
            } catch (err) {
                console.error("Error fetching program code:", err);
                setError("Error loading program code");
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        console.log('Rendering error state:', error);
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        console.log('Rendering loading state, szakKod is:', szakKod);
        return <div>Loading page...</div>;
    }

    console.log('Rendering LanguageProvider with szakKod:', szakKod);
    return (
        <LanguageProvider szakKod={szakKod}>
            <MegvalositasErtekelesContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default MegvalositasErtekeles;